import { Box, Button, Dialog, DialogActions, DialogTitle, DialogContent } from '@material-ui/core';
import React from 'react';
import { DropEvent, FileRejection } from 'react-dropzone';
import FileDrop from '../FileDrop';

interface Props {
    open: boolean;
    title?: string;
    onDrop?: (<T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) => void) | undefined;
    onClick?: () => void;
    onClose?: () => void;
}

function FileUpload(props: Props) {

    const { title = 'Upload de Arquivo' } = props;

    const [file, setFile] = React.useState<File>();

    function handleOnDrop<T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) {
        setFile(acceptedFiles[0]);
        if (props.onDrop) props.onDrop(acceptedFiles, fileRejections, event);
    }

    function handleClose() {
        setFile(undefined);
        if (props.onClose) props.onClose();
    }

    return (
        <Dialog open={props.open}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Box width={500}>
                    <FileDrop
                        maxFiles={1}
                        onDrop={handleOnDrop}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    color="primary">
                    Fechar
                </Button>
                {file &&
                    <Button
                        disabled={!file}
                        onClick={props.onClick}
                        color="primary">
                        Importar
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}

export default FileUpload;